import { schema } from 'normalizr';
import { SchemaKeys } from '../core';
export const projectSchema = new schema.Entity(SchemaKeys.Projects, {}, {
    idAttribute: 'projectId'
});
